import React from 'react';
import AppHeader from './AppHeader';

export default function ModalComponent({ children }) {
    return (<div className="backdrop">
        <div className="modalContainer">
            <AppHeader appName="Docshare" showAuthentication={false} />
            <div className="modalContent">
                {children}
            </div>
        </div>
    </div>);
}